// extracted by mini-css-extract-plugin
module.exports = {"wait":"wait--r-Xxm","success":"success--IN6Yh","error":"error--f6cem"};